(function () {
  const sectionName = 'Text columns with images';
  const dataSection = 'text-columns';

  if (sectionName in Shopify.theme.sections.registered) {
    const sections = document.querySelectorAll(`[data-section-type=${dataSection}]`);

    sections.forEach((section, index) => {
      if (index !== 0) {
        const scriptTag = section.querySelector('script');
        if(scriptTag) {
          scriptTag.remove();
        }
      }
    });
  } else {
    Shopify.theme.sections.register(sectionName);

    const allSections = document.querySelectorAll(".grid.grid--flush-bottom");

    allSections.forEach(sectionWithcards => {
      const cards = sectionWithcards.querySelectorAll(".grid__item");

      cards.forEach(card => {
        const popUp = card.querySelector(".pop-up");
        const closeButton = card.querySelector(".pop-up__close-button");

        card.addEventListener("click", function showPopUp() {
          popUp.classList.add("active");
        })

        closeButton.addEventListener("click", function hidePopUp(event) {
          popUp.classList.remove("active");
          event.stopPropagation();
        })
      })
    })
  }
}());